module.exports = __webpack_public_path__ + "post-listing-cross-promotoe-ico-1-1PSgKW2.png";